/* SENVIA Bundles – własny zamiennik Kaching Bundles */
(function () {
  if (window.__svBundlesLoaded) return;
  window.__svBundlesLoaded = true;

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    function group(int, sep) { return int.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    var map = {
      amount: group(parts[0], ',') + '.' + parts[1],
      amount_no_decimals: group(String(Math.round(cents / 100)), ','),
      amount_with_comma_separator: group(parts[0], '.') + ',' + parts[1],
      amount_no_decimals_with_comma_separator: group(String(Math.round(cents / 100)), '.'),
      amount_with_space_separator: group(parts[0], ' ') + ',' + parts[1],
      amount_with_apostrophe_separator: group(parts[0], "'") + '.' + parts[1]
    };
    return (format || '{{amount_with_comma_separator}} zł').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      return map[key] || map.amount_with_comma_separator;
    });
  }

  function findVariant(product, values) {
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === values[i]; });
    });
  }

  function selectValues(container) {
    return Array.prototype.map.call(container.querySelectorAll('select.sv-select'), function (s) { return s.value; });
  }

  // Nazwa pliku zdjęcia bez rozszerzenia i bez doklejanego przez Shopify _uuid
  function imageBase(src) {
    return (src || '').split('?')[0].split('/').pop()
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '')
      .toLowerCase();
  }

  function SvBundles(root) {
    this.root = root;
    this.data = JSON.parse(root.querySelector('[data-sv-product]').textContent);
    this.moneyFormat = root.dataset.moneyFormat;
    this.sectionId = root.dataset.sectionId;
    this.bars = Array.prototype.slice.call(root.querySelectorAll('[data-sv-bar]'));
    this.form = this.findForm();
    this.bind();
    this.bars.forEach(this.refreshBar, this);
    this.syncFormVariant();
  }

  SvBundles.prototype.findForm = function () {
    var form = this.sectionId && document.getElementById('product-form-' + this.sectionId);
    if (form) return form;
    var scope = this.root.closest('section, product-info, .shopify-section') || document;
    return scope.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('product-form[data-main="true"] form[action*="/cart/add"]');
  };

  SvBundles.prototype.selectedBar = function () {
    return this.root.querySelector('.sv-bar--selected');
  };

  SvBundles.prototype.bind = function () {
    var self = this;

    this.bars.forEach(function (bar) {
      bar.addEventListener('click', function (e) {
        if (bar.classList.contains('sv-bar--selected')) return;
        if (e.target.closest('select')) return;
        self.selectBar(bar);
      });
      bar.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === bar) {
          e.preventDefault();
          self.selectBar(bar);
        }
      });
    });

    this.root.addEventListener('change', function (e) {
      var select = e.target.closest('select.sv-select');
      if (!select) return;
      var bar = select.closest('[data-sv-bar]');
      var mainRow = select.closest('[data-sv-main-row]');
      if (mainRow) self.syncUpsellSize(bar, mainRow);
      self.refreshBar(bar);
      self.syncFormVariant();
    });

    // Lista rozmiarów w pasku "sticky" motywu ustawia rozmiar poduszki #1 w widgecie
    document.addEventListener('change', function (e) {
      var select = e.target.closest && e.target.closest('sticky-atc select');
      if (!select || self.root.contains(select)) return;
      var option = select.options[select.selectedIndex];
      var values = ((option && option.dataset.options) || select.value).split(',');
      var bar = self.selectedBar();
      var row = bar && bar.querySelector('[data-sv-main-row]');
      if (!row) return;
      row.querySelectorAll('select.sv-select').forEach(function (s, idx) {
        if (values[idx] !== undefined) s.value = values[idx].trim();
      });
      self.syncUpsellSize(bar, row);
      self.refreshBar(bar);
      self.syncFormVariant();
    });

    this.root.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-sv-upsell-toggle]');
      if (toggle) {
        e.preventDefault();
        self.toggleUpsell(toggle.closest('[data-sv-upsell-row]'));
        return;
      }
      var link = e.target.closest('[data-sv-upsell-link]');
      if (link && self.showInGallery(link)) e.preventDefault();
    });

    this.root.addEventListener('keydown', function (e) {
      var toggle = e.target.closest('.sv-checkbox');
      if (toggle && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        self.toggleUpsell(toggle.closest('[data-sv-upsell-row]'));
      }
    });

    // Przejmujemy "Dodaj do koszyka" zanim zrobi to motyw (faza capture)
    document.addEventListener('submit', function (e) {
      if (!self.form || e.target !== self.form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      self.addToCart();
    }, true);

    // Przycisk w pasku "sticky" motywu dodaje do koszyka własnym fetch-em (z pominięciem submit),
    // więc przejmujemy też jego kliknięcie
    document.addEventListener('click', function (e) {
      if (!self.form) return;
      var button = e.target.closest('sticky-atc button, button[form]');
      if (!button || self.form.contains(button)) return;
      if (!button.closest('sticky-atc') && button.getAttribute('form') !== self.form.getAttribute('id')) return;
      if (button.closest('sticky-atc') && !button.classList.contains('main-product-atc')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      self.addToCart();
    }, true);
  };

  SvBundles.prototype.selectBar = function (bar) {
    var previous = this.selectedBar();
    if (previous === bar) return;

    // Zachowaj wybrane rozmiary przy zmianie pakietu
    if (previous) {
      var prevRows = previous.querySelectorAll('[data-sv-main-row]');
      var nextRows = bar.querySelectorAll('[data-sv-main-row]');
      Array.prototype.forEach.call(nextRows, function (row, i) {
        var source = prevRows[Math.min(i, prevRows.length - 1)];
        if (!source) return;
        var values = selectValues(source);
        row.querySelectorAll('select.sv-select').forEach(function (s, idx) {
          if (s.value !== values[idx]) s.value = values[idx];
        });
        this.syncUpsellSize(bar, row);
      }, this);
      previous.classList.remove('sv-bar--selected');
      previous.setAttribute('aria-checked', 'false');
    }

    bar.classList.add('sv-bar--selected');
    bar.setAttribute('aria-checked', 'true');
    this.refreshBar(bar);
    this.syncFormVariant();
  };

  // Poszewka nr i dostaje rozmiar/wiek poduszki nr i (klient może go potem zmienić ręcznie)
  SvBundles.prototype.syncUpsellSize = function (bar, mainRow) {
    var mainRows = Array.prototype.slice.call(bar.querySelectorAll('[data-sv-main-row]'));
    var index = mainRows.indexOf(mainRow);
    var upsellRow = bar.querySelectorAll('[data-sv-upsell-row]')[index];
    if (!upsellRow) return;
    var mainValues = selectValues(mainRow);
    upsellRow.querySelectorAll('select.sv-select').forEach(function (s) {
      mainValues.forEach(function (value) {
        var match = Array.prototype.some.call(s.options, function (o) { return o.value === value; });
        if (match) s.value = value;
      });
    });
  };

  SvBundles.prototype.toggleUpsell = function (row) {
    if (!row) return;
    var box = row.querySelector('.sv-checkbox');
    var checked = !box.classList.contains('sv-checkbox--checked');
    box.classList.toggle('sv-checkbox--checked', checked);
    box.setAttribute('aria-checked', String(checked));
    row.classList.toggle('sv-upsell--off', !checked);
  };

  SvBundles.prototype.mainVariants = function (bar) {
    var main = this.data.main;
    var rows = bar.querySelectorAll('[data-sv-main-row]');
    var qty = parseInt(bar.dataset.quantity, 10);
    if (!rows.length) {
      var single = main.variants[0];
      var list = [];
      for (var i = 0; i < qty; i++) list.push(single);
      return list;
    }
    return Array.prototype.map.call(rows, function (row) {
      return findVariant(main, selectValues(row));
    });
  };

  SvBundles.prototype.refreshBar = function (bar) {
    var self = this;
    var discount = parseInt(bar.dataset.discount, 10) || 0;
    var variants = this.mainVariants(bar).filter(Boolean);
    if (variants.length) {
      var total = 0;
      var compare = 0;
      variants.forEach(function (v) {
        total += v.price - discount;
        compare += Math.max(v.compare, v.price);
      });
      var priceEl = bar.querySelector('[data-sv-total-price]');
      var compareEl = bar.querySelector('[data-sv-total-compare]');
      var unitEl = bar.querySelector('[data-sv-unit-price]');
      if (priceEl) priceEl.textContent = formatMoney(total, this.moneyFormat);
      if (compareEl) compareEl.textContent = formatMoney(compare, this.moneyFormat);
      if (unitEl) unitEl.textContent = formatMoney(variants[0].price - discount, this.moneyFormat);
    }

    var upsell = this.data.upsell;
    if (!upsell) return;
    bar.querySelectorAll('[data-sv-upsell-row]').forEach(function (row) {
      var variant = upsell.variants.length === 1 ? upsell.variants[0] : findVariant(upsell, selectValues(row));
      if (!variant) return;
      row.dataset.variantId = variant.id;
      row.querySelector('[data-sv-upsell-price]').textContent = formatMoney(variant.price, self.moneyFormat);
      row.querySelector('[data-sv-upsell-compare]').textContent =
        variant.compare > variant.price ? formatMoney(variant.compare, self.moneyFormat) : '';
      var img = row.querySelector('.sv-upsell__image');
      if (img && variant.image && img.getAttribute('src') !== variant.image) img.setAttribute('src', variant.image);
      var link = row.querySelector('[data-sv-upsell-link]');
      if (link) link.setAttribute('href', upsell.url + '?variant=' + variant.id);
      row.classList.toggle('sv-upsell--unavailable', !variant.available);
    });
  };

  // Ustawia ukryte pole "id" formularza motywu na wariant pierwszej poduszki
  SvBundles.prototype.syncFormVariant = function () {
    var bar = this.selectedBar();
    if (!bar || !this.form) return;
    var first = this.mainVariants(bar)[0];
    var input = this.form.querySelector('input[name="id"]');
    if (first && input) input.value = first.id;

    // Pasek "sticky" pokazuje rozmiar poduszki #1
    var sticky = document.querySelector('sticky-atc select.sticky-atc__variant-select');
    if (first && sticky) {
      var match = Array.prototype.find.call(sticky.options, function (o) {
        return o.dataset.variantId === String(first.id);
      });
      if (match && !match.selected) sticky.value = match.value;
    }
  };

  // Klik w miniaturę poszewki pokazuje jej zdjęcie w galerii produktu (jeśli tam jest)
  SvBundles.prototype.showInGallery = function (link) {
    var img = link.querySelector('img');
    var base = imageBase(img && img.getAttribute('src'));
    var gallery = document.querySelector('media-gallery');
    if (!base || !gallery || typeof gallery.setActiveMedia !== 'function') return false;
    var slide = Array.prototype.find.call(
      gallery.querySelectorAll('li[id^="Slide-"][data-media-id]'),
      function (li) {
        var i = li.querySelector('img');
        return i && imageBase(i.currentSrc || i.src) === base;
      }
    );
    if (!slide) return false;
    gallery.setActiveMedia(slide.dataset.mediaId, false);
    var rect = gallery.getBoundingClientRect();
    if (rect.top < 0 || rect.top > window.innerHeight * 0.5) {
      gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    return true;
  };

  // Zwraca { main: poduszki, extras: poszewki + ebook }
  SvBundles.prototype.buildItems = function (bar, cart) {
    var main = [];
    var extras = [];
    function push(list, id, quantity) {
      var existing = list.find(function (it) { return it.id === id; });
      if (existing) existing.quantity += quantity;
      else list.push({ id: id, quantity: quantity });
    }

    var variants = this.mainVariants(bar);
    if (variants.some(function (v) { return !v; })) throw new Error('Przepraszamy, nie jest to obecnie dostępne.');
    if (variants.some(function (v) { return !v.available; })) {
      throw new Error('Wybrany rozmiar jest niedostępny. Wybierz inny rozmiar.');
    }
    variants.forEach(function (v) { push(main, v.id, 1); });

    bar.querySelectorAll('[data-sv-upsell-row]').forEach(function (row) {
      if (!row.querySelector('.sv-checkbox--checked')) return;
      var id = parseInt(row.dataset.variantId, 10);
      if (id && !row.classList.contains('sv-upsell--unavailable')) push(extras, id, 1);
    });

    var gift = this.data.gift;
    if (gift && gift.available) {
      var inCart = cart && cart.items && cart.items.some(function (it) { return it.variant_id === gift.variantId; });
      if (!inCart) push(extras, gift.variantId, 1);
    }
    // Shopify pokazuje w koszyku ostatnio dodaną pozycję na górze, więc wysyłamy w odwrotnej
    // kolejności, żeby w koszyku było: poduszki → poszewki → ebook
    return { main: main.reverse(), extras: extras.reverse() };
  };

  // fetch z ukrytej ramki – nasłuch koszyka Shopify (i pixele, np. Meta) go nie widzi, więc
  // poszewki i ebook nie są liczone jako osobne AddToCart. Liczy się tylko dodanie poduszek, jak w Kaching.
  SvBundles.prototype.untrackedFetch = function (url, init) {
    if (!this.silentFrame || !this.silentFrame.contentWindow) {
      var frame = document.createElement('iframe');
      frame.style.display = 'none';
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('tabindex', '-1');
      document.body.appendChild(frame);
      this.silentFrame = frame;
    }
    var win = this.silentFrame.contentWindow;
    return win && typeof win.fetch === 'function' ? win.fetch(url, init) : fetch(url, init);
  };

  // Cofa dodanie dodatków, gdy nie uda się dodać poduszek (żeby w koszyku nie zostały same poszewki)
  SvBundles.prototype.revertExtras = function (added) {
    var self = this;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return (added || []).reduce(function (chain, line) {
      return chain.then(function () {
        return self.untrackedFetch(location.origin + root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: Math.max(0, line.previousQuantity) })
        }).catch(function () {});
      });
    }, Promise.resolve());
  };

  SvBundles.prototype.setLoading = function (loading) {
    if (!this.form) return;
    var button = this.form.querySelector('[type="submit"], [name="add"]');
    if (!button) return;
    button.classList.toggle('sv-atc-loading', loading);
    if (loading) button.setAttribute('aria-disabled', 'true');
    else button.removeAttribute('aria-disabled');
    var spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
  };

  SvBundles.prototype.showError = function (message) {
    var productForm = this.form && this.form.closest('product-form');
    var wrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
    if (wrapper) {
      wrapper.querySelector('.product-form__error-message').textContent = message || '';
      wrapper.toggleAttribute('hidden', !message);
    } else if (message) {
      alert(message);
    }
  };

  SvBundles.prototype.addToCart = function () {
    var self = this;
    var bar = this.selectedBar();
    if (!bar || this.busy) return;
    this.busy = true;
    this.showError('');
    this.setLoading(true);

    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotification = document.querySelector('cart-notification');
    var renderer = cartDrawer && typeof cartDrawer.renderContents === 'function' ? cartDrawer
      : cartNotification && typeof cartNotification.renderContents === 'function' ? cartNotification
      : null;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
    function readJson(r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) throw new Error(json.description || json.message || 'Nie udało się dodać do koszyka.');
        return json;
      });
    }

    var items;
    var addedExtras = [];
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (cart) {
        items = self.buildItems(bar, cart);
        if (!items.extras.length) return null;
        // 1) poszewki + ebook – bez zdarzenia AddToCart
        var before = {};
        ((cart && cart.items) || []).forEach(function (it) { before[it.key] = it.quantity; });
        return self.untrackedFetch(location.origin + root + 'cart/add.js', {
          method: 'POST',
          headers: jsonHeaders,
          body: JSON.stringify({ items: items.extras })
        })
          .then(readJson)
          .then(function (json) {
            addedExtras = (json.items || []).map(function (it) {
              return { key: it.key, previousQuantity: before[it.key] || 0 };
            });
          });
      })
      .then(function () {
        // 2) poduszki – jedno zwykłe dodanie do koszyka (AddToCart dla pixeli)
        var body = { items: items.main };
        if (renderer && typeof renderer.getSectionsToRender === 'function') {
          body.sections = renderer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: jsonHeaders,
          body: JSON.stringify(body)
        })
          .then(readJson)
          .catch(function (err) {
            return self.revertExtras(addedExtras).then(function () { throw err; });
          });
      })
      .then(function (response) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'senvia-bundles', cartData: response });
        }
        if (!renderer || !response.sections) {
          window.location.href = root + 'cart';
          return;
        }
        try {
          if (cartDrawer) cartDrawer.classList.remove('is-empty');
          renderer.renderContents(response);
        } catch (err) {
          console.error('[SENVIA Bundles]', err);
          window.location.href = root + 'cart';
        }
      })
      .catch(function (err) {
        console.error('[SENVIA Bundles]', err);
        self.showError(err.message);
      })
      .then(function () {
        self.busy = false;
        self.setLoading(false);
      });
  };

  function init() {
    document.querySelectorAll('[data-sv-bundles]').forEach(function (root) {
      if (root.__svBundles) return;
      root.__svBundles = new SvBundles(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
